import React, { Component } from "react";

import ReactPaginate from "react-paginate";

class Pagination extends Component {

  selectPage = ({ selected }) => {
    if(Number(this.props.currentPage) === (selected + 1)) {
      return;
    }

    this.props.selectPage(selected + 1);
  }

  render() {
    // don't show pagination component if there are no pages to surf ;)
    if (this.props.totalPages <= 1) {
      return null;
    }

    return (
      <ReactPaginate
          previousLabel={<button className="btn simple">Previous</button>}
          nextLabel={<button className="btn simple">Next</button>}
          breakLabel={'...'}
          breakClassName={'break-me'}
          activeLinkClassName={'btn simple'}
          pageLinkClassName={'btn simple'}
          pageCount={this.props.totalPages}
          forcePage={this.props.currentPage - 1}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={this.selectPage}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
    );
  }
}

export default Pagination;
